import Vue from 'vue'
import Router from 'vue-router'

import Login from '@v/login'
import Main from '@v/main'
import Notfound from '@v/404'

// 单据类
import BillList from '@v/bill/list'
import BillInfo from '@v/bill/info'
// import BillAdd from '@v/bill/add'
// import BillEdit from '@v/bill/edit'

// 报货单
import BaohuoAdd from '@v/baohuo/add.vue'
import BaohuoEdit from '@v/baohuo/edit.vue'

// 三包理赔
import CheckinAdd from '@v/checkin/add.vue'
import CheckinEdit from '@v/checkin/edit.vue'

// 三包理赔
import CheckoutAdd from '@v/checkout/add.vue'
import CheckoutEdit from '@v/checkout/edit.vue'

// 胎号管理
import ChecktaiAdd from '@v/checktai/add.vue'
import ChecktaiEdit from '@v/checktai/edit.vue'

// 查询类
import Search from '@v/search'

// 下载类型
import Download from '@v/download'

// 采购差额调账
import AdjustAdd from '@v/adjust/add.vue'
import AdjustEdit from '@v/adjust/edit.vue'

// 客户回款－银行回款登记单
import PaymentCheckinAdd from '@v/payment/checkin/add.vue'
import PaymentCheckinInfo from '@v/payment/checkin/info.vue'
import PaymentCheckinEdit from '@v/payment/checkin/edit.vue'

// 客户回款－银行回款确认单
import PaymentConfirmInfo from '@v/payment/confirm/info.vue'
import PaymentConfirmAdd from '@v/payment/confirm/add.vue'

// 客户汇款－往来查询
import PaymentContactsIndex from '@v/payment/contactsquery/index.vue'

// 2018-05-17 往来账插入需求
// 现金回款
import PaymentBashbackAdd from '@v/payment/cashback/add.vue'
import PaymentBashbackEdit from '@v/payment/cashback/edit.vue'

// 银行账户
import BankAccountAdd from '@v/payment/bankaccount/add.vue'
import BankAccountEdit from '@v/payment/bankaccount/edit.vue'

// 供应商 2017-12-11添加
import SupplierAdd from '@v/material/supplier/add.vue'
import SupplierEdit from '@v/material/supplier/edit.vue'

// 品牌 2017-12-11添加
import BrandsAdd from '@v/material/brands/add.vue'
import BrandsEdit from '@v/material/brands/edit.vue'

// 仓库 2017-12-11添加
import WarehouseAdd from '@v/material/warehouse/add.vue'
import WarehouseEdit from '@v/material/warehouse/edit.vue'

// 员工 2017-12-11添加
import StaffAdd from '@v/material/staff/add.vue'
import StaffEdit from '@v/material/staff/edit.vue'

// 货品标签 2017-12-11添加
import TagAdd from '@v/material/tag/add.vue'
import TagEdit from '@v/material/tag/edit.vue'

// 权限 2018-01-05添加
import PowerAdd from '@v/power/add.vue'
import PowerEdit from '@v/power/edit.vue'

// 第29批 发票管理 2018-03-13添加
// 发票登记
import InvoiceCheckinAdd from '@v/invoice/checkin/add.vue'
import InvoiceCheckinEdit from '@v/invoice/checkin/edit.vue'
import InvoiceCheckinInfo from '@v/invoice/checkin/info.vue'
// 发票统计
import InvoiceStatistics from '@v/invoice/statistics'
// 第37批 客户开票信息
import KehukpAdd from '@v/invoice/kehukp/add.vue'
import KehukpEdit from '@v/invoice/kehukp/edit.vue'

// 其他付款 2018-05-30添加，第34批需求
import PaymentOtherpayAdd from '@v/payment/otherpay/add.vue'
import PaymentOtherpayEdit from '@v/payment/otherpay/edit.vue'
import PaymentOtherpayInfo from '@v/payment/otherpay/info.vue'

// 功能权限开关管理
import QuanxianSwitchList from '@v/material/quanxianswitch/list.vue'
// 扎帐
import AccountingZhazhang from '@v/material/accounting/index.vue'

// bi销售任务 2018-10-25添加
import SetTask from '@v/material/task/set.vue'

// 客户级别 2021-12-28添加 by welpher
import CusLevelAdd from '@v/cuslevel/add.vue'
import CusLevelEdit from '@v/cuslevel/edit.vue'

// 月度计划 2023-04-24添加 by zjs
import MonthduizhangAdd from '@v/material/monthduizhang/add.vue'
import MonthduizhangEdit from '@v/material/monthduizhang/edit.vue'

Vue.use(Router)

// Handle navigation duplication for router push (Globally)

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(() => {
  });
};

export default new Router({

    routes: [ {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            authorizd: false
        }
    },
    {
        path: '/',
        component: Main,
        children: [
        // {
        //     path: '',
        //     redirect: to => {
        //         return '/bill'
        //     }
        // }, 
        // {
        //     path: 'bill',
        //     redirect: to => {
        //         return '/bill/checkin/list'
        //     }
        //     // name: 'Bill',
        //     // component: Bill
        // }, 
        {
            path: '/bill/gongnengquanxian/list',
            name: 'QuanxianSwitchList',
            component: QuanxianSwitchList
        },

        {
            path: '/bill/:name/list',
            name: 'BillList',
            component: BillList
        }, 
        /* ----------单独配置的详情 start---------- */
        { // 银行回款登记详情页，单独配置
            path: '/bill/paycheckin/info/:id',
            name: 'PaymentCheckinInfo',
            component: PaymentCheckinInfo
        },
        { // 银行回款确认详情页，单独配置
            path: '/bill/payconfirm/info/:id',
            name: 'PaymentConfirmInfo',
            component: PaymentConfirmInfo
        }, 
        { // 往来查询
            path: '/contacts/query',
            name: 'PaymentContactsIndex',
            component: PaymentContactsIndex
        },
        { // 发票登记的详情
            path: '/bill/invoice/info/:id',
            name: 'InvoiceCheckinInfo',
            component: InvoiceCheckinInfo
        },
        { // 其他收付的详情
            path: '/bill/qitasf/info/:id',
            name: 'PaymentOtherpayInfo',
            component: PaymentOtherpayInfo
        },
        { // 扎帐
            path: '/accounting/zhazhang',
            name: 'AccountingZhazhang',
            component: AccountingZhazhang
        },
        /* ----------单独配置的详情 end---------- */
        {
            path: '/bill/:name/info/:id',
            name: 'BillInfo',
            component: BillInfo
        }, 

        // {
        //     path: '/bill/:name/add',
        //     name: 'BillAdd',
        //     component: BillAdd
        // }, 
        {
            path: '/bill/baohuo/add',
            name: 'BaohuoAdd',
            component: BaohuoAdd
        }, // 报货单的新增页面
        {
            path: '/bill/baohuo/edit/:id',
            name: 'BaohuoEdit',
            component: BaohuoEdit
        }, // 报货单的修改页面
        {
            path: '/bill/checkin/add',
            name: 'CheckinAdd',
            component: CheckinAdd
        }, // 三包登记的新增页面
        {
            path: '/bill/checkin/edit/:id',
            name: 'CheckinEdit',
            component: CheckinEdit
        }, // 三包登记的修改页面
        {
            path: '/bill/checkout/add',
            name: 'CheckoutAdd',
            component: CheckoutAdd
        }, // 三包理赔的新增页面
        {
            path: '/bill/checkout/edit/:id',
            name: 'CheckoutEdit',
            component: CheckoutEdit
        }, // 三包理赔的修改页面
        {
            path: '/bill/checktai/add',
            name: 'ChecktaiAdd',
            component: ChecktaiAdd
        }, // 胎号管理的新增页面
        {
            path: '/bill/checktai/edit/:id',
            name: 'ChecktaiEdit',
            component: ChecktaiEdit
        }, 
        {
            path: '/search/:name',
            name: 'search',
            component: Search
        }, {
            path: '/download/:name',
            name: 'download',
            component: Download
        }, 
        // 采购差额调账
        {
            path: '/bill/adjust/add',
            name: 'AdjustAdd',
            component: AdjustAdd
        }, {
            path: '/bill/adjust/edit/:id',
            name: 'AdjustEdit',
            component: AdjustEdit
        }, 
        // 银行登记单
        {
            path: '/bill/paycheckin/add',
            name: 'PaymentCheckinAdd',
            component: PaymentCheckinAdd
        }, {
            path: '/bill/paycheckin/edit/:id',
            name: 'PaymentCheckinEdit',
            component: PaymentCheckinEdit
        },
        // 银行对账单
        {
            path: '/bill/payconfirm/add',
            name: 'PaymentConfirmAdd',
            component: PaymentConfirmAdd
        },
        // 现金回款
        { 
            path: '/bill/cashback/add',
            name: 'PaymentBashbackAdd',
            component: PaymentBashbackAdd
        }, { 
            path: '/bill/cashback/edit/:id',
            name: 'PaymentBashbackEdit',
            component: PaymentBashbackEdit
        },
        // 银行账户
        {
            path: '/bill/bankaccount/add',
            name: 'BankAccountAdd',
            component: BankAccountAdd
        }, {
            path: '/bill/bankaccount/edit/:id',
            name: 'BankAccountEdit',
            component: BankAccountEdit
        }, 
        // 供应商
        {
            path: '/bill/provider/add',
            name: 'SupplierAdd',
            component: SupplierAdd
        }, {
            path: '/bill/provider/edit/:id',
            name: 'SupplierEdit',
            component: SupplierEdit
        }, 
        // 品牌
        {
            path: '/bill/productbrandlist/add',
            name: 'BrandsAdd',
            component: BrandsAdd
        }, {
            path: '/bill/productbrandlist/edit/:id',
            name: 'BrandsEdit',
            component: BrandsEdit
        }, 
        // 仓库
        {
            path: '/bill/warehouse/add',
            name: 'WarehouseAdd',
            component: WarehouseAdd
        }, {
            path: '/bill/warehouse/edit/:id',
            name: 'WarehouseEdit',
            component: WarehouseEdit
        },
        // 员工
        {
            path: '/bill/staff/add',
            name: 'StaffAdd',
            component: StaffAdd
        }, {
            path: '/bill/staff/edit/:id',
            name: 'StaffEdit',
            component: StaffEdit
        }, {
            path: '/bill/task/set',
            name: 'SetTask',
            component: SetTask
        },
        {
            path: '/bill/task/edit/:id',
            name: 'EditTask',
            component: SetTask
        },
        // 货品标签
        {
            path: '/bill/producttag/add',
            name: 'TagAdd',
            component: TagAdd
        }, {
            path: '/bill/producttag/edit/:id',
            name: 'TagEdit',
            component: TagEdit
        },
        // 权限
        {
            path: '/bill/quanxian/add',
            name: 'PowerAdd',
            component: PowerAdd
        },
        {
            path: '/bill/quanxian/edit/:id',
            name: 'PowerEdit',
            component: PowerEdit
        },
        // 发票管理 
        {
            path: '/bill/invoice/add',
            name: 'InvoiceCheckinAdd',
            component: InvoiceCheckinAdd
        }, {
            path: '/bill/invoice/edit/:id',
            name: 'InvoiceCheckinEdit',
            component: InvoiceCheckinEdit
        }, { // 发票统计
            path: '/invoice/:name',
            name: 'InvoiceStatistics',
            component: InvoiceStatistics
        }, 
        // 客户开票信息 37批添加
        {
            path: '/bill/kehukp/add',
            name: 'KehukpAdd',
            component: KehukpAdd
        },{
            path: '/bill/kehukp/edit/:id',
            name: 'KehukpEdit',
            component: KehukpEdit
        },
        // 其他付款
        {
            path: '/bill/qitasf/add',
            name: 'PaymentOtherpayAdd',
            component: PaymentOtherpayAdd
        }, {
            path: '/bill/qitasf/edit/:id',
            name: 'PaymentOtherpayEdit',
            component: PaymentOtherpayEdit
        },
        // 客户级别
        {
            path: '/bill/cusLevel/add',
            name: 'CusLevelAdd',
            component: CusLevelAdd
        }, {
            path: '/bill/cusLevel/edit/:id',
            name: 'CusLevelEdit',
            component: CusLevelEdit
        }, {
            path: '/bill/monthduizhang/add',
            name: 'MonthduizhangAdd',
            component: MonthduizhangAdd
        }, {
            path: '/bill/monthduizhang/edit/:id',
            name: 'MonthduizhangEdit',
            component: MonthduizhangEdit
        }
    ]
    }, {
        path: '*',
        name: 404,
        component: Notfound
    }]
})
